import { Row } from 'antd'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  margin-bottom: 1.625rem;
`
